import RestrictionDetailsModalRestrictionsDetailsRendererCoinValueItem from './CoinValueItem';
import { RestrictionDetailsModalRestrictionsDetailsRendererProps } from './props';
import { RestrictionCategoryId } from '@/models/restriction/category/id';

export default function RestrictionDetailsModalRestrictionsDetailsRenderer({
  userRestriction,
  restriction,
}: RestrictionDetailsModalRestrictionsDetailsRendererProps) {
  switch (
    userRestriction.restriction?.categoryId?.toString() ||
    restriction?.categoryId?.toString()
  ) {
    case RestrictionCategoryId.Deposit?.toString():
    case RestrictionCategoryId.Withdrawal?.toString():
    case RestrictionCategoryId.Spend?.toString():
    case RestrictionCategoryId.Stake?.toString():
      return (
        <RestrictionDetailsModalRestrictionsDetailsRendererCoinValueItem
          userRestriction={userRestriction}
          restriction={restriction}
        />
      );
    default:
      return null;
  }
}
